import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ReportPanel from './ReportPanel';
import Reports from './Reports';

const Results = (props) => {
  const { path } = useRouteMatch();
  const searchesInProgress = props.searchesInProgress;

  return (
    <div className='h-100'>
      <Switch>
        <Route exact path={`${path}`}>
          <Reports
            searchesInProgress={searchesInProgress}
            currentSearch={props.currentSearch}
            fetchingData={props.fetchingData}
            resultSets={props.resultSets}
            fetchNewResults={async () => await props.fetchNewResults()}
          />
        </Route>
        <Route path={`${path}/:search`}>
          <ReportPanel
            searchesInProgress={searchesInProgress}
            currentSearch={props.currentSearch}
            resultSets={props.resultSets}
            connections={props.connections}
            fetchNewResults={async () => await props.fetchNewResults()}
            handleSetMemo={(key, data) => props.handleSetMemo(key, data)}
            memo={props.memo}
          />
        </Route>
      </Switch>
    </div>
  );
}

export default Results;